window.addEventListener('DOMContentLoaded', (event) => {
	const client = ShopifyBuy.buildClient({
		domain: 'flexsteelstore.com',
		storefrontAccessToken: '2685a31493c96ae9b6dd94bfd76cfae6'
	});

	var configId = "";
	try{
		const element = document.querySelector('#configurator-id');
		configId = element.dataset.configuratorid;
	}catch(e){

	}

	PetiteVue.createApp({
		products: {},
		cart: [],
		viewerId: "flexsteel-configurator",
		storageId: "flexsteel-configurator"+configId,
		userConfigId: "56d21a72-96ee-4b7a-8937-81e6c86bfa75",//single armless chair, formerly 14901
		hideCart: false,
		hasError: false,
		loading: true,
		addingToCart: false,
		downloadingConfig: false,
		mapping: [],
		get price(){
			let price = 0;
			for(var i = 0; i < this.cart.length; i++){
				price += parseFloat(this.cart[i].price)*this.cart[i].qty;
			}
			return price.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
		},
		formatPrice(price){
			return parseFloat(price).toLocaleString('en-US', {style: 'currency', currency: 'USD'});
		},
		addToCart(){
			let cartObj = [];
			let local = this;
			for(const item in this.cart){
				cartObj.push({
					quantity: this.cart[item].qty,
					id: this.cart[item].id,
				});
			}
			this.addingToCart = true;
			jQuery.post('/cart/clear.json', {}, function() {
				jQuery.post('/cart/add.js', {items: cartObj}, function(){
					window.location.href = "/cart";
					local.addingToCart = false;

				})
				.fail(function(jqXHR, status, error) {
					local.addingToCart = false;
					// console.error('Error adding items to cart!!:', jqXHR, status, error);
					let message = "There was an error adding items to your cart.";
					if(jqXHR.responseText !== undefined){
						let response = JSON.parse(jqXHR.responseText);
						message += "\n\n"+response.description;
					}
					alert(message);
					window.location.href = "/cart";
				});
			});
		},
		downloadConfig(){
			this.downloadingConfig = true;
			var intiaroPlayer = getIntiaroPlayer(this.viewerId);
			intiaroPlayer.getProductSummaryUrl([0, 30, 90], (url)=>{
				console.log(url);
				window.open(url, '_blank');
				this.downloadingConfig = false;
			}, ()=>{ console.log('error'); });
		},
		updateConfig(){
			try{
				var player = getIntiaroPlayer("flexsteel-configurator");
				player.getModularConfiguration(true, (config)=>{
					this.setConfig(config);
				},
				(error)=>{
					console.log("error");
					console.log(error);
				});
			}catch(e){
				if(!this.hasError){
					// try again if we haven't loaded the configurator yet
					// setTimeout(() => {
					// 	this.updateConfig();
					// }, 1000);
				}
				this.hasError = true;

			}
		},
		setConfig(config){
			this.cart = [];
			for(const product in this.products){
				product.qty = 1;
			}
			for(const element in config.elements){
				let arms = config.elements[element].variables.flexsteel_arms.replace("flexsteel_", "").replace("arm_arm", "");
				let color = config.elements[element].variables.flexsteel_fabric.replace("flexsteel_15846_", "").replace("flexsteel_14955_", "").replace("flexsteel_31340_", "");
				let id = config.elements[element].element_id;
				let product = this.findProduct(id, color, arms);
				if(product !== undefined && product !== false){
					//check if in the cart already
					const index = this.cart.findIndex(item => item.id === product.id);
					if (index === -1) {
						// Item doesn't exist in cart, add it
						this.cart.push({...product});
					} else {
						if(this.cart[index].arms !== arms){
							this.cart[index].qty += 1;
						}
					}
				}
			}
		},
		async getAllProducts(){
			// const products = await client.product.fetchAll(250);
			//note that products need to be added to the "Flexsteel Configurator" sales channel and tagged with "Config_14901" to show up here.
			//also note that sometimes you need to re-tag the products to get them to show up in the query after adding the sales channel (shopify bug)
			const products = await client.product.fetchQuery({
				first: 250,
				query: "tag:Config_14901"
			});
			//console.log(products);


			//for debugging
			// const handle = '9022-72t-31302';
			// client.product.fetchByHandle(handle).then((product) => {
			// 	console.log(product);
			// });

			const productsQuery = client.graphQLClient.query((root) => {
				root.addConnection('products', { args: { first: 250, query:"tag:Config_14901" } }, (product) => {
					product.add('id');
					product.add('title');
					product.add('metafields', { args: {	identifiers: [{ key: 'config-id', namespace: 'intiaro' }],},},
						(metafield) => {
						  metafield.add('namespace')
						  metafield.add('key')
						  metafield.add('value')
					});
				});
			});

			client.graphQLClient.send(productsQuery).then(({ model, data }) => {
				for(const product in data.products.edges){
					for(metafield in data.products.edges[product].node?.metafields){
						if(data.products.edges[product].node?.metafields[metafield]?.value !== undefined){
							this.mapping.push([data.products.edges[product].node.metafields[metafield]?.value, data.products.edges[product].node.title]);
						}
					}
				}

				// console.log("mapping", this.mapping);
				const productObject = {};

				products.forEach(product => {
					product.variants.forEach(variant => {
						let color = "";
						let arms = "";
						let configSku = "";
						if(product.title.includes("Pebble")){
							color = "pebble";
						}else if(product.title.includes("Frost")){
							color = "frost";
						}else if(product.title.includes("Denim")){
							color = "denim";
						}
						if(product.title.includes("Narrow Arms")){
							arms = "narrow";
						}else if(product.title.includes("Wide Arms")){
							arms = "wide";
						}else if(product.title.includes("Standard Arms")){
							arms = "standard_arm";
						}
						for(const id in this.mapping){
							if(product.title.includes(this.mapping[id][1])){
								configSku = this.mapping[id][0];
							}
						}
						if(configSku !== ""){
							productObject[variant.sku] = {
								id: variant.id.replace("gid://shopify/ProductVariant/", ""),
								image: product.images[0].src+"&width=200",
								title: product.title,
								qty: 1,
								handle: product.handle,
								sku: variant.sku,
								color: color,
								arms: arms,
								configSku: configSku,
								price: variant.price.amount
							};
						}
					});
				});
				this.products = productObject;


			});
			// console.log(products);


		},
		findProduct(configSku, color, arms){
			if(configSku === "18723"){
				configSku = "18722";
			}
			//search allProducts by the configSku, color, and arms variables
			const filteredProducts = Object.values(this.products).filter(product => {
				// console.log(product.configSku === configSku, product.color === color, product.arms === arms);
				if(product.arms !== ""){
					return product.configSku == configSku && product.color === color && product.arms === arms;
				}else{
					return product.configSku === configSku && product.color === color;
				}
			});
			if(filteredProducts.length == 1){
				return filteredProducts[0];
			}else{
				console.log("not found", configSku, color, arms);
			}
			return false;
		},
		configuratorListener(){
			IntiaroConfigurator.create(this.viewerId).then((configuratorInstance)=>{
				configuratorInstance.viewer.registerListener("configurationChanged", (config) => {
					this.setConfig(config);
					var intiaroPlayer = getIntiaroPlayer(this.viewerId);
					intiaroPlayer.saveConfiguration((configId) => {
						this.userConfigId = configId;
						console.log("configId", configId);
						try {
							localStorage.setItem(this.storageId, configId);
						}catch(e){
							console.error('localStorage not available:', e);
						}
					});
				});
				configuratorInstance.viewer.registerListener("isSectionalBuilderOpen", (response) => {
					console.log("builderOpen", response);
					this.hideCart = response.isSectionalBuilderOpen;
				});

				this.updateConfig();

				//add our cart to the page
				let cart = document.getElementById("flexsteel-inline-cart");
				// overflowWrapper = document.querySelector("#"+this.viewerId+" .overflowWrapper .menu-separator");
				// overflowWrapper = document.querySelector(".intiaroController");
				// overflowWrapper.appendChild(cart);
				cart.classList.remove("hide");
				this.sizeCart();
				// this.addVideo();

			});

			//start with a sectional both arms chair on right side of snake

			/*
			document.getElementById("save-current-modular-configuration").onclick = function(){
				var intiaroPlayer = getIntiaroPlayer("flexsteel-configurator");
				intiaroPlayer.saveConfiguration( (configId) => {
				  console.log(configId);

				//   // attach saved configuration id to "data-product-id" of second configurator and add "data-mode='user_configuration'" attribute
				//   // this will initialize second configurator with saved configuration
				//   var second360Configurator = document.getElementById("second360Configurator");
				//   second360Configurator.setAttribute("data-product-id", savedConfigurationId);
				//   second360Configurator.setAttribute("data-mode", "user_configuration");

				//   // launch second configurator
				//   IntiaroConfigurator.create("second360Configurator");
				});
			}
			*/
		},
		assignUserConfigId(){
			let user = true;
			try {
				const queryString = window.location.search;
				const urlParams = new URLSearchParams(queryString);
				const preset = parseInt(urlParams.get('preset'));

				if(preset && typeof preset === 'number'){
					//if a preset is present in the URL use that as the basis, but remove it from the URL so future refreshes don't use it
					console.log("Using preset config: ", preset);
					urlParams.delete('preset');
					const newUrl = window.location.pathname + '?' + urlParams.toString();
					history.replaceState(null, '', newUrl);
					this.userConfigId = preset;
					user = false;
				}else{
					let configId = localStorage.getItem(this.storageId);
					if(configId !== null && configId !== undefined && configId !== ""){
						this.userConfigId = configId;
					}
				}

			}catch(e){
				console.error('localStorage not available:', e);
			}
			configurator = document.getElementById(this.viewerId);
			configurator.setAttribute("data-product-id", this.userConfigId);
			if(user){
				configurator.setAttribute("data-mode", "user_configuration");
			}
		},
		sizeCart(){
			let cart = document.getElementById("flexsteel-inline-cart");
			const position = window.getComputedStyle(cart).getPropertyValue('position');
			if(position === "absolute"){
				let viewer = document.getElementById(this.viewerId);
				let rightColumnWidth = viewer.querySelector('.intiaroController')?.offsetWidth;
				let dividerHeight = viewer.querySelector('.menu-separator')?.offsetTop;
				cart.style.maxWidth = (rightColumnWidth - 60)+"px";
				cart.style.top = (dividerHeight + 10)+"px";
			}else{
				cart.style.maxWidth = '';
				cart.style.top = '';
			}
		},
		//adds a video in place of text the first time the configurator is opened
		addVideo(){
			const targetNode = document.querySelector('body');

			const observer = new MutationObserver(function (mutations) {
				mutations.forEach(function (mutation) {
					if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
						const addedNode = mutation.addedNodes[0];
						if (addedNode !== null && addedNode.matches('.swal2-container')) {
							let container = document.getElementById("swal2-html-container");
							if (container !== null) {
								let video = document.createElement("video");
								let videoHolder = container.querySelector('span');
								videoHolder.innerHTML = "";
								video.src = '/assets/configurator-instructions.mp4';
								video.controls = false;
								video.muted = true;
								video.autoplay = true;
								videoHolder.appendChild(video);
							}
						}
					}
				});
			});
			const config = { attributes: false, childList: true, subtree: false };
			observer.observe(targetNode, config);
		},
		async mounted(){
			await this.getAllProducts();
			this.assignUserConfigId();
			this.configuratorListener();
			this.sizeCart();
			const scope = this;
			window.addEventListener('resize', function() {
				scope.sizeCart();
			});
			this.loading = false;
		}
	}).mount("#flexsteel-inline-cart");
});
